// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import L from 'leaflet';
import Backbone from 'backbone';
import myw from 'myWorld-base';

myw.RelatedNotes = myw.Control.extend({
    events: {
        'click .feature-plugins-header': 'toggleNotesList'
    },
    /**
     * @class Control that allows users to view and access the notes related to a feature.
     * @param  {NotesPlugin}   owner   Owner of self
     * @constructs
     * @extends {Control}
     */
    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);
        this.database = this.app.database;
        this.map = this.app.map;

        this.noteMarkers = []; //map highlight when mouseover note

        this.relatedNotesPane = null;

        this.relNotesDiv = $('<div class="feature-plugins-header collapsed"></div>')
            .text(this.msg('notes'))
            .appendTo(this.$el);
        this._notesList = $('<div class="notes-list"/>').appendTo(this.$el);
    },

    render(feature) {
        this.getRelatedNotes(feature).then(notes => {
            if (notes.length > 0) {
                //store the notes so they can be displayed when the section is expanded
                this.currentFeatureNotes = notes;

                this.hideNotesList();

                this.$el.show();
            } else {
                this.$el.hide();
                this.currentFeatureNotes = null;
            }
        });
    },

    toggleNotesList() {
        if (!this._notesList.is(':visible')) {
            this.showRelatedNotes(this.currentFeatureNotes);
        }
        this._notesList.toggle();
        this.relNotesDiv.toggleClass('collapsed');
    },

    hideNotesList() {
        this._notesList.hide();
        this.relNotesDiv.toggleClass('collapsed', true);
    },

    getRelatedNotes(feature) {
        return this.database.getFeaturesByValue(
            'note',
            'referenced_feature',
            '=',
            feature.getUrn()
        );
    },

    showRelatedNotes(relatedNotes) {
        this._notesList.empty();
        for (let i = 0; i < relatedNotes.length; i++) {
            //features;
            const noteContainer = new RelatedNoteView({
                control: this,
                note: relatedNotes[i]
            });
            this._notesList.append(noteContainer.$el);
        }
    }
});

/*
 * Creates a note to be dislayed in the list of related notes
 */
const RelatedNoteView = Backbone.View.extend({
    className: 'note-container',
    events: {
        mouseover: 'flashNote',
        mouseout: 'clearMarkers',
        click: 'goToNote'
    },

    initialize(options) {
        this.note = options.note;
        this.control = options.control;
        this.app = this.control.app;

        this.render();
    },

    render() {
        const title = this.note.getTitle() || this.app.currentFeature.getTitle(),
            noteDetails = this.note.properties.details !== null ? this.note.properties.details : '',
            theHtml = `<div class='noteTitle'><strong>${_.escape(title)}</strong>: ${_.escape(
                noteDetails
            )}</div>`;

        this.$el.html(theHtml);
        this.control.translate(this.$el);
    },

    /*
     * Sets the note as the current feature
     */
    goToNote() {
        this.app.setCurrentFeature(this.note, true);
    },

    /**
     * Adds a marker to the map to highlight the note
     * @private
     */
    flashNote() {
        const x = this.note.geometry.coordinates[0],
            y = this.note.geometry.coordinates[1];
        const noteMarker = new L.Marker([y, x], {
            icon: new L.Icon({
                iconUrl: 'images/circle-empty2.png',
                iconAnchor: [18, 18]
            })
        }).addTo(this.app.map);

        this.control.noteMarkers.push(noteMarker);
    },

    clearMarkers() {
        if (this.control.noteMarkers) {
            for (const marker in this.control.noteMarkers) {
                this.app.map.removeLayer(this.control.noteMarkers[marker]);
            }
            this.control.noteMarkers.length = 0;
        }
    }
});
export default myw.RelatedNotes;
